export default {
  blue: "#B6DDE0",
  white: "#fff",
  boxShadow: "rgba(0,0,0,0.06) 0px 3px 6px;",
  nearBlack: "#1A1919",
  grey: "#696969"
};
